module.exports = __webpack_public_path__ + "img/bank-icon-disabled.041d0327.svg";